import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import './ForgotPassword.css';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(true);
  const navigate = useNavigate();
  const { token } = useParams();
  
  useEffect(() => {
    if (!token) {
      setIsTokenValid(false);
      setError('Недійсне посилання для скидання паролю');
    } else {
      
      validateToken();
    }
  }, [token]);

  const validateToken = async () => {
    try {
      
      
    } catch (err) {
      setIsTokenValid(false);
      setError('Термін дії посилання закінчився або воно недійсне');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== confirmPassword) {
      setError('Паролі не співпадають');
      return;
    }
    
    if (password.length < 6) {
      setError('Пароль має містити принаймні 6 символів');
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await axios.post('https://test2.planfix-to-syrve.com/reset-password', {
        token,
        password
      });
      setMessage(response.data.message || 'Пароль успішно змінено');
      
      setTimeout(() => {
        navigate('/login', { 
          state: { 
            message: 'Пароль успішно змінено. Тепер ви можете увійти з новим паролем.' 
          } 
        });
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Сталася помилка при зміні пароля');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <div className="reset-password-header">
          <h1 className="reset-password-title">Встановлення нового паролю</h1>
          <p className="reset-password-subtitle">
            Введіть новий пароль для вашого акаунту
          </p>
        </div>
        
        <div className="reset-password-card">
          {isTokenValid ? (
            <form onSubmit={handleSubmit} className="reset-password-form">
              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  Новий пароль
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Мінімум 6 символів"
                  required
                  className="form-input"
                  disabled={isLoading}
                />
                <div className="password-hint">
                  Пароль має містити принаймні 6 символів
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="confirmPassword" className="form-label">
                  Підтвердіть пароль
                </label>
                <input
                  id="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Повторіть пароль"
                  required
                  className="form-input"
                  disabled={isLoading}
                />
              </div>
              
              {message && (
                <div className="success-message">
                  <svg className="success-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {message}
                  <div className="redirect-message">
                    Перенаправлення на сторінку входу...
                  </div>
                </div>
              )}
              
              {error && (
                <div className="error-message">
                  <svg className="error-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {error}
                </div>
              )}
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="button-loading">
                    <span className="spinner"></span>
                    Збереження...
                  </span>
                ) : (
                  'Зберегти новий пароль'
                )}
              </button>
            </form>
          ) : (
            <div className="invalid-token-message">
              <svg className="invalid-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.3639C14.8493 21.8787 9.15078 21.8787 5.63607 18.3639C2.12136 14.8492 2.12136 9.15074 5.63607 5.63604C9.15079 2.12132 14.8493 2.12132 18.364 5.63604" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <h3>Не дійсне посилання</h3>
              <p>Посилання для скидання паролю недійсне або термін його дії закінчився.</p>
              <button 
                className="request-new-link-button"
                onClick={() => navigate('/forgot-password')}
              >
                Запитати нове посилання
              </button>
            </div>
          )}
        </div>
        
        {isTokenValid && (
          <div className="reset-password-footer">
            <button 
              type="button"
              className="back-to-login-button"
              onClick={() => navigate('/login')}
            >
              ← Повернутися до входу
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;